import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "about-us-mobile" }
const _hoisted_2 = { class: "gsjs" }
const _hoisted_3 = { class: "gsjs-img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "szlc-box" }
const _hoisted_6 = { class: "szlc" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "development-line" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "szlc-content" }
const _hoisted_12 = { class: "szlc-content-text" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "ryzz honor" }
const _hoisted_15 = { class: "ryzz-list" }
const _hoisted_16 = { class: "honor-card" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "qywh" }
const _hoisted_19 = { class: "qywh-content" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "q1" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "q1" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "q1" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "zmt" }
const _hoisted_28 = { class: "zmt-content" }
const _hoisted_29 = ["src"]
const _hoisted_30 = ["src"]
const _hoisted_31 = ["src"]
const _hoisted_32 = ["src"]
const _hoisted_33 = ["src"]
const _hoisted_34 = ["src"]

import { ref, onMounted } from 'vue'
import type { CarouselInstance } from 'element-plus'
import BannerC from '@/components/BannerC.vue';
import { asynchronousRetrieval } from '@/utils'
import { ElCarousel, ElCarouselItem } from 'element-plus'

export default /*@__PURE__*/_defineComponent({
  __name: 'AboutUsView',
  setup(__props) {

const loadUrl: any = ref({})

const years: any = [
  {
    name: '2016',
    content: [
      {
        text: '2016是中国VR元年 凝丰智能应势而生',
      },
      {
        text: '瞄准前瞻市场快速推进业务'
      },
    ]
  },
  {
    name: '2017',
    content: [
      {
        text: '布局线上营销网络'
      },
      {
        text: '与当时VR领头羊品牌HTC VIVE合作签约'
      }
    ]
  },
  {
    name: '2018',
    content: [
      {
        text: '开始布局全国行业渠道网络'
      }
    ]
  },
  {
    name: '2019',
    content: [
      {
        text: '深度融合元宇宙生态'
      },
      {
        text: '为行业赋能解决方案新价值'
      }
    ]
  },
  {
    name: '2020',
    content: [
      {
        text: '跃居XR领域头部公司'
      },
      {
        text: '<span>与一线品牌商合作突破 </span><span class="blods">30家</span>',
      },
      {
        text: '<span>建立起渠道合作伙伴近 </span><span class="blods">1000家</span>',
      },
      {
        text: '<span>线上服务客户突破 </span><span class="blods">百万</span>',
      }
    ]
  },
  {
    name: '2021',
    content: [
      {
        text: '<span class="blods">整体营收破亿 </span><span>企业快速稳健发展</span>'
      },
      {
        text: '高速发展备受资本市场关注',
      },
      {
        text: '在行业数智化领域沉淀技术',
      }
    ]
  },
  {
    name: '2022',
    content: [
      {
        text: '成立研发团队'
      },
      {
        text: '<span>着重深耕 </span><span class="blods">数智化底层技术研发</span>'
      },
      {
        text: '同年6月 完成天使轮融资',
        color: '#D71819'
      }
    ]
  },
  {
    name: '2023',
    content: [
      {
        text: '元宇宙虚实融合应用平台（混空系统 Mixed Space）发布'
      },
      {
        text: '面向工业、文娱、教育提供成熟的数智化解决方案 促进元宇宙应用落地、为产业提质增效'
      },
      {
        text: '2023 上海最具投资潜力50佳创业企业',
        color: '#D71819'
      },
      {
        text: '“创客中国”元宇宙（人工智能）',
        inlineBlock: true
      },
      {
        text: '专业赛一等奖',
        color: '#D71819',
        inlineBlock: true
      }
    ]
  },
  {
    name: '2024',
    content: [
      { text: '<span>旗下混空公司获评 </span><span style="color: #D71819">国家双软企业</span>' },
      { text: '<span>旗下混空公司获评 </span><span style="color: #D71819">上海软件核心竞争力企业</span>' },
      { text: '<span>旗下混空公司获评 </span><span style="color: #D71819">国家科技型中小企业</span>' },
      { text: '<span>旗下混空公司获评 </span><span style="color: #D71819">数字中国创新大赛数字文旅赛道优胜奖</span>' }
    ]
  },
  {
    name: '2025',
    content: [
      { text: '<span>旗下混空公司获评 </span><span style="color: #D71819">国家高新技术企业</span>' },
      { text: '<span>旗下混空公司 </span><span style="color: #D71819">数字人导航首发</span>' },
      { text: '<span>旗下混空公司 </span><span style="color: #D71819">混空AI大模型上线</span>' },
      { text: '<span>旗下混空公司 </span><span style="color: #D71819">自研采集软件上线</span>' },
      { text: '<span>旗下混空公司 </span><span style="color: #D71819">多个标杆文旅项目成功落地</span>' },
      { text: '<span>旗下混空公司 </span><span style="color: #D71819">多项元宇宙价值奖项斩获</span>' },
      { text: '<span style="color: #D71819">央视</span>等权威媒体报道' },
      { text: '多次亮相<span style="color: #D71819">国家级活动</span>' }
    ]
  }
]
const honors = [
  {
    url: require('/public/images/about-us/ryzz8.jpg'),
    illustrate: ['高新技术企业']
  },
  {
    url: require('/public/images/about-us/ryzz1.png'),
    illustrate: ['2023上海最具投资潜力', '50佳创业企业']
  },
  {
    url: require('/public/images/about-us/ryzz2.png'),
    illustrate: ['“创客中国”元宇宙（人工智能）', '专业赛 一等奖']
  },
  {
    url: require('/public/images/about-us/ryzz3.png'),
    illustrate: ['2023数智创新优胜奖']
  },
  {
    url: require('/public/images/about-us/ryzz4.png'),
    illustrate: ['诺亦腾年度最佳合作伙伴']
  },
  {
    url: require('/public/images/about-us/ryzz5.png'),
    illustrate: ['VIVE2023年度销量金牌']
  },
  {
    url: require('/public/images/about-us/ryzz6.png'),
    illustrate: ['与圆周率达成全国战略合作']
  },
  {
    url: require('/public/images/about-us/ryzz7.png'),
    illustrate: ['上海市创新创业大赛 优胜奖']
  },
]
const active_f_i = ref(0)
const honorsCarouselRef = ref<CarouselInstance>()

const prevEvent = () => {
  honorsCarouselRef.value?.prev()
}

const nextEvent = () => {
  honorsCarouselRef.value?.next()
}

onMounted(async () => {
  const shiming: any = await asynchronousRetrieval('nfznxr-images/about-us/shiming.png');
  const yuanjing: any = await asynchronousRetrieval('nfznxr-images/about-us/yuanjing.png');
  const jiazhiguan: any = await asynchronousRetrieval('nfznxr-images/about-us/jiazhiguan.png');
  const gongzhonghao: any = await asynchronousRetrieval('nfznxr-images/about-us/gongzhonghao.png');
  const shipinhao: any = await asynchronousRetrieval('nfznxr-images/about-us/shipinhao.png');
  const douyin: any = await asynchronousRetrieval('nfznxr-images/about-us/douyin.png');
  const xiaohongshu: any = await asynchronousRetrieval('nfznxr-images/about-us/xiaohongshu.png');
  const bilibili: any = await asynchronousRetrieval('nfznxr-images/about-us/bilibili.png');
  const weibo: any = await asynchronousRetrieval('nfznxr-images/about-us/weibo.png');
  const gsjs: any = await asynchronousRetrieval('nfznxr-images/about-us/gsjs.png');
  const fzlc_bg: any = await asynchronousRetrieval('nfznxr-images/about-us/fzlc-bg.png');
  const development_line: any = await asynchronousRetrieval('nfznxr-images/about-us/development-line.png');
  const qywh_bg: any = await asynchronousRetrieval('nfznxr-images/about-us/qywh-bg.png');
  const qywh: any = await asynchronousRetrieval('nfznxr-images/about-us/qywh.png');
  loadUrl.value = { shiming, yuanjing, jiazhiguan, gongzhonghao, shipinhao, douyin, xiaohongshu, bilibili, weibo, gsjs, fzlc_bg, development_line, qywh_bg, qywh }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BannerC),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title-font-style-m" }, "公司介绍", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "content" }, [
        _createElementVNode("div", null, "上海凝丰智能科技有限公司伴随着2016中国VR元年应势而生，作为国内元宇宙生态服务的先行者，持续深耕前沿科技产品趋势、技术、营销和服务，在整合提升产业链价值的过程中，已迭代为“数智化生态服务商”，为上下游企业提供所需的渠道开拓、产品分销、技术研发、数智化解决方案等服务，释放生态互联价值，成为企业实现数智化增长的可靠伙伴。"),
        _createElementVNode("div", null, "凝丰智能总部位于上海，目前数智化营销渠道已覆盖全国，在元宇宙XR领域的市场份额和合作伙伴数量均处于国内领先地位，分销品类正向数智类全面扩容。其自研的元宇宙数实融合技术已申请多项国家专利和商标，以专业的硬件搭载领先的自研技术，面向工业、文娱、教育等各个领域提供一站式数智化前沿解决方案，让科技转化成现实价值。")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: loadUrl.value.gsjs
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title-font-style-m" }, "发展历程", -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("img", {
          src: loadUrl.value.fzlc_bg
        }, null, 8, _hoisted_7),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(years, (item, index) => {
            return _createElementVNode("div", {
              key: index,
              class: _normalizeClass(active_f_i.value == index ? 'active-f' : '')
            }, [
              _createElementVNode("div", {
                onClick: ($event: any) => (active_f_i.value = index)
              }, null, 8, _hoisted_9),
              _createElementVNode("div", {
                onClick: ($event: any) => (active_f_i.value = index)
              }, _toDisplayString(item.name), 9, _hoisted_10)
            ], 2)
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", null, _toDisplayString(years[active_f_i.value].name), 1),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(years[active_f_i.value].content, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              style: _normalizeStyle({ color: item.color || '#333', display: item.inlineBlock ? 'inline-block' : '' })
            }, [
              _createElementVNode("span", {
                innerHTML: item.text
              }, null, 8, _hoisted_13)
            ], 4))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title-font-style-m" }, "荣誉资质", -1)),
      _createElementVNode("div", {
        class: "prev",
        onClick: prevEvent
      }),
      _createElementVNode("div", {
        class: "next",
        onClick: nextEvent
      }),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_unref(ElCarousel), {
          ref_key: "honorsCarouselRef",
          ref: honorsCarouselRef,
          trigger: "click",
          arrow: "never",
          "indicator-position": "none",
          autoplay: true,
          interval: 3000,
          loop: true,
          "pause-on-hover": false,
          height: "340rem",
          type: "card"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(honors, (item, index) => {
              return _createVNode(_unref(ElCarouselItem), {
                key: item.url + index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("img", {
                      src: item.url
                    }, null, 8, _hoisted_17),
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.illustrate, (e, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(e), 1))
                      }), 128))
                    ])
                  ])
                ]),
                _: 2
              }, 1024)
            }), 64))
          ]),
          _: 1
        }, 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "title-font-style-m" }, "企业文化", -1)),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("img", {
          src: loadUrl.value.qywh_bg
        }, null, 8, _hoisted_20),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("img", {
              src: loadUrl.value.shiming
            }, null, 8, _hoisted_22),
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "使命", -1))
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "q2" }, "推动元宇宙科学技术进步，促进社会数智化发展", -1)),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("img", {
              src: loadUrl.value.yuanjing
            }, null, 8, _hoisted_24),
            _cache[5] || (_cache[5] = _createElementVNode("span", null, "愿景", -1))
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "q2" }, "成为全球最具价值元宇宙生态服务商", -1)),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("img", {
              src: loadUrl.value.jiazhiguan
            }, null, 8, _hoisted_26),
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "价值观", -1))
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "q2" }, "诚信守诺、持续奋斗、执行第一、成就员工、合作伙伴至上", -1))
        ])
      ])
    ]),
    _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"lxwm\" data-v-e4154a06><div class=\"title-font-style-m\" data-v-e4154a06>联系我们</div><div class=\"lxwm-content\" data-v-e4154a06><div data-v-e4154a06><div class=\"s1\" data-v-e4154a06>上海</div><div class=\"s2\" style=\"color:#D71819;\" data-v-e4154a06>上海总部</div><div class=\"s3\" data-v-e4154a06>上海市徐汇区钦州北路1001号光启园7号楼6层</div><div class=\"s3\" data-v-e4154a06>总机电话：400-900-6269</div></div><div data-v-e4154a06><div class=\"s1\" data-v-e4154a06>北京</div><div class=\"s2\" data-v-e4154a06>北京分公司</div><div class=\"s3\" data-v-e4154a06>张僚</div><div class=\"s3\" data-v-e4154a06>18035958866</div></div><div data-v-e4154a06><div class=\"s1\" data-v-e4154a06>西安</div><div class=\"s2\" data-v-e4154a06>西安分公司</div><div class=\"s3\" data-v-e4154a06>顾凯</div><div class=\"s3\" data-v-e4154a06>15214330809</div></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_27, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "title-font-style-m" }, "自媒体账号", -1)),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: loadUrl.value.gongzhonghao
            }, null, 8, _hoisted_29),
            _cache[11] || (_cache[11] = _createElementVNode("span", null, "公众号", -1))
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: loadUrl.value.shipinhao
            }, null, 8, _hoisted_30),
            _cache[12] || (_cache[12] = _createElementVNode("span", null, "视频号", -1))
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: loadUrl.value.douyin
            }, null, 8, _hoisted_31),
            _cache[13] || (_cache[13] = _createElementVNode("span", null, "抖音", -1))
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: loadUrl.value.xiaohongshu
            }, null, 8, _hoisted_32),
            _cache[14] || (_cache[14] = _createElementVNode("span", null, "小红书", -1))
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: loadUrl.value.bilibili
            }, null, 8, _hoisted_33),
            _cache[15] || (_cache[15] = _createElementVNode("span", null, "bilibili", -1))
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: loadUrl.value.weibo
            }, null, 8, _hoisted_34),
            _cache[16] || (_cache[16] = _createElementVNode("span", null, "微博", -1))
          ])
        ])
      ])
    ])
  ]))
}
}

})